import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESetPagesMetaActionType, TSetPagesMeta } from './types';
import { IPageInfoSchema } from '../../repositories/journal/entities/page_info/PageInfoSchema';

export const setPagesMeta: (data: IPageInfoSchema[]) => TSetPagesMeta = actionGenerator<
  ESetPagesMetaActionType.Set,
  IPageInfoSchema[]
>(ESetPagesMetaActionType.Set);
